// extracted by mini-css-extract-plugin
export default {"container":"StickControl_container__d6YyA","wrapper":"StickControl_wrapper__EDrv7"};